import { createStore } from 'vuex'

export default createStore({
  state() {
      return {
          sw_version:'0.1',
          login: false,
          office: null,
          pricepermonth: 15,
          business:true,
          no_offices: null,
          live_appointments:null,
          current_business:null,
          suspendend_account:null,
          bcandidate:null,
          appoint_office_id:null,
          petId:null,
      }
  },
  mutations: {
      setPetId(state,value){
          state.petId = value
      },
      setAppointOfficeId(state,value) {
         state.appoint_office_id = value
      },
      setBCandidateMonths(state,value) {
          state.bcandidate.subscription_months = value
      },
      setBCandidate(state,value){
          state.bcandidate = value
      },
      setSuspendedAccount(state,value){
        state.suspendend_account = value
      },
      setCurrentBusinessName(state,value){
        state.current_business.name = value
      },
      setCurrentBusinessLocation(state,value){
          state.current_business.location = value
      },
      setCurrentBusiness(state,value){
          state.current_business = value
      },
      setLiveAppointments(state,value) {
          state.live_appointments = value
      },
      setNumberOffices(state,value) {
          state.no_offices = value
      },
      setBusinessUi(state,value) {
          state.business = value
      },
      setPricePerMonth(state,value) {
          state.pricepermonth = value
      },
      setSwVersion(state,value) {
          state.sw_version = value
      },
      setLoginState(state,value) {
          state.login = value
      },
      setSelectedOffice(state,value) {
          state.office = value
      }
  },
  getters: {
      getPetId: state => {
        return state.petId
      },
      getAppointOfficeId: state => {
          return state.appoint_office_id
      },
      getBCandidate: state => {
          return state.bcandidate
      },
      getSuspendedAccount: state => {
          return state.suspendend_account
      },
      getCurrentBusiness: state => {
          return state.current_business
      },
      getLiveAppointments: state => {
          return state.live_appointments
      },
      getBusinessName: state => {
        return state.current_business.name
      },
      getNoOffices: state  => {
          return state.no_offices
      },
      getPricePerMonth: state => {
        return state.pricepermonth
      },
      getSwVersion: state => {
          return state.sw_version
      },
      getLoginState: state => {
          return state.login
      },
      getBusiness: state => {
          return state.business
      },
      getSelectedOffice: state => {
          return state.office
      }
  },
  modules: {
  }
})
